module.exports = __webpack_public_path__ + "img/KSC05325.6f725c3e.jpg";